export default "__VITE_ASSET__DqYNuN86__"